import React from "react";
import Card from "react-bootstrap/Card";
import { useState } from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { BusinessData } from "../../../../constants/jsonConstant";
import { Col, Row } from "react-bootstrap";
import Cards from "../../Component/Card";
import { images } from "../../../../constants";
import PostCvModal from "../PostCvModal";
import "./style.css";
import useBusinessModeData from "../../../../hooks/businessMode/useBusinessModeData";

const businessModeDisplayOrder = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 22,
];
const sellingCardLabels = {
  1: { heading: "Business Dashboard" },
  2: { heading: "Retailer Markets", card: "Retailer's" },
  3: { heading: "Wholesale Markets", card: "Wholesaler's" },
  4: { heading: "Industrial Markets", card: "Industrial's" },
  5: { heading: "Raw Material Markets", card: "Raw Material's" },
  6: { heading: "Offer Jobs", card: "Jobs Recruitment Offers" },
  7: { heading: "Candidates Avaliable", card: "Candidates Avaliable" },
  8: { heading: "Gems & Jewelry Markets", card: "Gems & Jewelry" },
  9: { heading: "2nd Hand Item Markets", card: "2nd Hand Items" },
  10: { heading: "HomeMade Markets", card: "HomeMade Items" },
  11: { heading: "Single Item", card: "Single Item" },
  12: { heading: "Real Estate & Properties", card: "Properties" },
  13: { heading: "Vehicle Markets", card: "Vehicles" },
  14: { heading: "Transportation & Shipment", card: "Transport Providers" },
  15: { heading: "Recycled Markets", card: "Recycled Material" },
  16: { heading: "Services Market", card: "Services Providers" },
  17: { heading: "Agriculture Markets", card: "Seeds & Tools" },
  18: { heading: "Personal Property", card: "Personal Property" },
  19: { heading: "Food and Restaurant", card: "Food Providers" },
  22: { heading: "Help Center", card: "Helpline" },
};

const BusinessModes = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { scrapform, singleform, personalform, cvform } = useBusinessModeData();
  const businessModeData = BusinessData
    .filter((data) => businessModeDisplayOrder.includes(data.id))
    .sort(
      (first, second) =>
        businessModeDisplayOrder.indexOf(first.id) -
        businessModeDisplayOrder.indexOf(second.id),
    );

  return (
    <>
      <PostCvModal handleClose={handleClose} show={show} />
      <div>
        <Row className="set-one set-onetwo mx-2 mx-sm-0">
          {businessModeData.map((data) => {
            const sellingLabels = sellingCardLabels[data.id];
            return (
              <Col
                key={data.id}
                lg="3"
                md="3"
                sm="6"
                xs="12"
                className={`mt-3 ${data.id === 1 ? "business-dashboard-column" : ""}`}
              >
                <CardNav
                  Header={sellingLabels?.heading || data.title}
                  para={data.para}
                  myid={data.id}
                  myinfo={data.info}
                ></CardNav>
                <Card
                  className={`shadow-main mt-2 ${
                    data.id === 1 ? "business-dashboard-card" : ""
                  }`}
                >
                  {(data.id === 1 && (
                    <Cards
                      ms="four-element"
                      btn="Business Dashboard"
                      text=""
                      profileurl="/homemade-items-shops"
                      myclass="business_avataar"
                      imgsrc={images.Businessdashboard}
                    />
                  )) ||
                  (data.id === 2 && (
                    <BoxData

                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.Retailer}
                      url="/retailer-integrate"
                      link="/buy-retailer"
                      ms="eight-element"
                      buy="eight"
                    />
                  )) ||
                  (data.id === 3 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.WholeSaler}
                      url="/wholeseller-integrate"
                      link="/buy-wholeseller"
                      ms="six-element"
                      buy="six"
                    />
                  )) ||
                  (data.id === 4 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.Factory}
                      url="/manufacturer-integrate"
                      link="/buy-manufacturer"
                      className="mt-2"
                      ms="seven-element"
                      buy="seven"
                    />
                  )) ||
                  (data.id === 5 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.IronLogo}
                      url="/raw-integrate"
                      link="/buy-raw-material"
                      ms="eight-element"
                      buy="eight"
                    />
                  )) ||
                  (data.id === 6 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.Candidates}
                      ms="nine-element"
                      buy="nine"
                      url="/company-form"
                      link="/find-job"
                    />
                  )) ||
                  (data.id === 7 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.Jobs}
                      cvform={cvform}
                      handleShow={handleShow}
                      link="/find-candidates"
                      ms="ten-element"
                      buy="ten"
                    />
                  ))
                  ||
                  (data.id === 8 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.GemStone}
                      url="/gems-integrate"
                      link="/buy-minerals"
                      className="mt-2"
                      ms="seven-element"
                      buy="seven"
                    />
                  )) ||
                  (data.id === 9 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.UsedItems}
                      url="/useditems-integrate"
                      link="/buy-usedItems"
                      ms="eight-element"
                      buy="eight"
                    />
                  )) ||
                  (data.id === 10 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.Homemadetwo}
                      url="/Homemade-integrate"
                      link="/buy-homemade"
                      ms="six-element"
                      buy="six"
                    />
                  )) ||
                  (data.id === 11 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.SingleAdds}
                      url={singleform?.length > 0 ? "/singleadd-show" : "/post-single-ad"}
                      link="/single-item-buy"
                      ms="fourteen-element"
                      buy="fourteen"
                    />
                  )) ||
                  (data.id === 12 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.SellProperties}
                      url="/property-integrate"
                    />
                  ))

                  ||
                  (data.id === 13 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.BuyVehicles}
                      url="/usedvehicle-integrate"
                    />
                  )) ||
                  (data.id === 14 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.TransportServices}
                      url="/transport-integrate"
                    />
                  )) ||
                  (data.id === 15 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.Recycled}
                      url="/recycled-integrate"
                    />
                  )) ||
                  (data.id === 16 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.Services}
                      url="/service-integrate"
                    />
                  ))
                  ||
                  (data.id === 17 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.Farming}
                      url="/farming-integrate"
                    />
                  )) ||
                  (data.id === 18 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.SingleVehicle}
                      url={personalform?.length > 0 ? "/personal-add" : "/add-personal-property"}
                    />
                  )) ||
                  (data.id === 19 && (
                    <BoxData
                      Butonn="Create Now"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.Foodbar}
                      url="/restaurant-integrate"
                    />
                  )) ||
                  (data.id === 22 && (
                    <BoxData
                      Butonn="Help Line"
                      Title={sellingLabels?.card || data.title}
                      imgg={images.HelpLine}
                      url="/customer-support"
                    />
                  ))
                }
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </>
  );
};

export default BusinessModes;
